import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';

import { Skeleton } from 'antd';

import { getProvider } from '../util/url';
import { cleanString } from '../util/renderHelper';
import { gtmError } from '../util/gtm';

// Layouts
import PrintView from './PrintView';

// Components
import ProviderDashboard from './ProviderDashboard';

// Actions
import * as actions from '../actions';

class DashboardPage extends Component {
  constructor(props) {
    super(props);
    const providerSlug = props.location.pathname.split('/')[1];
    const provider = getProvider(props.providers, providerSlug);
    this.dashboardRef = React.createRef();

    this.state = {
      provider: provider,
      print: false
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    document.title = `Provider Dashboard: ${cleanString(
      this.state.provider.name
    )}`;

    window.localStorage &&
      window.localStorage.setItem('tac-provider', this.state.provider.id);

    this.getProviderDetails();

    if (match.params.subSection) {
      dispatch(actions.currentProviderActions.openCurrentProcessInfo());
    }

    window
      .matchMedia('print')
      .addListener(mq => this.setState({ print: mq.matches }));
  }

  componentDidUpdate(prevProps) {
    const {
      match,
      providerDetailsLoading,
      dispatch,
    } = this.props;
    if (
      prevProps.match.params.providerSection !== match.params.providerSection &&
      !match.params.providerSection
    ) {
      dispatch(actions.currentProviderActions.closeCurrentContent());
    }
  }

  getProviderDetails() {
    const { dispatch } = this.props;
    const { provider } = this.state;

    dispatch(actions.fetchActions.getProviderDetails(provider.id));
  }

  render() {
    const {
      providerDetails,
      providerDetailsError,
      providerDetailsLoading,
    } = this.props;

    const displayContent = (
      <Skeleton active loading={providerDetailsLoading}>
        {providerDetailsError && gtmError()}
        {!providerDetailsError && Object.keys(providerDetails).length > 0 && (
          <ProviderDashboard />
        )}
        {providerDetailsError && (
          <div>There was a problem loading the Provider Dashboard.</div>
        )}
      </Skeleton>
    );
    return (
      <div
        className={`provider-dashboard${
          providerDetailsLoading ? ' loading' : ''
        }`}
        ref={this.dashboardRef}
      >
        {!this.state.print ? (
          displayContent
        ) : (
          <PrintView>{displayContent}</PrintView>
        )}
        <div className="hidden">
          <img alt="header print" src={window.sq.state.site.printHeaderImg} />
          <img alt="footer print" src={window.sq.state.site.printFooterImg} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  providerDetails: state.providerDetails.data,
  providerDetailsError: state.providerDetails.error,
  providerDetailsLoading: state.providerDetails.loading,
  providers: state.providers.data,
});

export default connect(mapStateToProps)(DashboardPage);
